import React, { createContext, ReactNode, useContext } from 'react';

/**
 * The URL prefix the module is mounted at. The host app decides this at the
 * mount point (e.g. `/roi/partner-data-gateway` inside the shell, or `/` if
 * the module is ever extracted into its own standalone app) and passes it
 * in via `<BasePathProvider>`. Pages/components must build links and
 * `navigate()` calls from `useBasePath()` instead of hardcoding a route
 * path, so the module keeps working after it moves.
 */
const BasePathContext = createContext<string>('');

export interface BasePathProviderProps {
  basePath: string;
  children: ReactNode;
}

export const BasePathProvider = ({
  basePath,
  children,
}: BasePathProviderProps): JSX.Element => (
  <BasePathContext.Provider value={basePath}>
    {children}
  </BasePathContext.Provider>
);

export const useBasePath = (): string => useContext(BasePathContext);
